import { UnknowErrorException } from '@/domain/common/exceptions';
export const validatePersonExecute = async (
  document,
  validateClientService,
  validateNonClientService
) => {
  const {
    codRes: responseCodeClient,
    data: dataClient,
    message: messageClient,
  } = await validateClientService(document);
  if (responseCodeClient === '00') {
    return {
      responseCodeClient,
      dataPerson: dataClient[0],
      event: 'CLIENT_FOUND',
    };
  } else if (responseCodeClient === '02') {
    const {
      responseCode: responseCodeNonClient,
      data: dataNonClient,
      message: messageNonClient,
    } = await validateNonClientService(document);
    if (responseCodeNonClient === '00') {
      return {
        responseCodeNonClient,
        dataPerson: dataNonClient[0],
        event: 'NON_CLIENT_REGISTERED',
      };
    } else if (responseCodeNonClient === '02') {
      return {
        responseCodeNonClient,
        dataPerson: null,
        event: 'NON_CLIENT_UNREGISTERED',
      };
    } else {
      throw new UnknowErrorException({
        errorCode: responseCodeNonClient,
        messageNonClient,
      });
    }
  } else {
    throw new UnknowErrorException({
      errorCode: responseCodeClient,
      messageClient,
    });
  }
};
